module.exports = __webpack_public_path__ + "882be535ace6d399d1fd5419826ad926.svg";